var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup9552(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 109,
    height: 109,
    viewBox: "0 0 109 109",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-4 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-1 {\r\n        stroke: #1700f4;\r\n        stroke-width: 6px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #fff;\r\n        opacity: 0.5;\r\n      }\r\n\r\n      .cls-3 {\r\n        stroke: none;\r\n      }\r\n\r\n      .cls-5 {\r\n        filter: url(#Ellipse_31);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_31",
    x: 0,
    y: 0,
    width: 109,
    height: 109,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.561
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_955",
    "data-name": "Group 955",
    transform: "translate(-761.5 -718.5)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5",
    transform: "matrix(1, 0, 0, 1, 761.5, 718.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_31-2",
    "data-name": "Ellipse 31",
    className: "cls-1",
    transform: "translate(4.5 3.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 50,
    cy: 50,
    r: 50
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 50,
    cy: 50,
    r: 47
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_33",
    "data-name": "Ellipse 33",
    className: "cls-2",
    cx: 28,
    cy: 28,
    r: 28,
    transform: "translate(788 744)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup9552);
export default __webpack_public_path__ + "static/media/Group_955-2.60eb2787165caa98db69dc447050dcd3.svg";
export { ForwardRef as ReactComponent };